import script from "./prediction-drawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./prediction-drawer.vue?vue&type=script&lang=ts&setup=true"

import "./prediction-drawer.vue?vue&type=style&index=0&id=2ea13dea&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ea13dea"]])

export default __exports__